export default {
  dashboard: '概览',
  system_manage: '系统管理',
  simulation_manage: '模拟还款管理',
  account_settings: '账户设置',
  simulation_qr_payment: '模拟Qr Code还款',
  simulation_bank_transfer_payment: '模拟Bank Transfer还款',
  simulation_payout: '模拟代付',
  simulation_payment: '模拟静态码还款',
  simulation_dynamic_payment: '模拟动态订单还款',
  simulation_checkout_payment: '模拟收银台订单还款',
  simulation_refund: '模拟退款',
  simulation_collection_verify: '模拟静态VA收单校验',
  customerService_manage: '客户服务',
  transaction_manage: '交易管理',
  refund_transaction_query: '退款交易查询',
  customerService_manage_query_pay: '收款业务查询',
  customerService_manage_query_payout: '付款业务查询',
  customer_service_ticket_list: '工单管理',
  customer_service_manage_query_card_verification: '验卡业务查询',
  develop_manage: '开发者',
  application_manage_list: '配置',
  application_manage_detail: '应用详情',
  institute_plan_template: '息费组合模板',
  user_list: '用户管理',
  role_list: '角色管理',
  financial: '资金管理',
  financial_setting: '资金设置',
  payin: '收款交易',
  payout: '付款交易',
  loan: '借款交易',
  repayment: '还款交易',
  balance: '余额管理',
  account_balance: '账户余额',
  balance_details: '余额明细',
  top_up: '充值',
  questionnaire: '反洗钱问卷',
  deposits: '存款',
  transaction_summary: '交易汇总',
  online_payment: 'Payment Links',
  send_payments: 'Send Payments',
  online_payout: '小额付款',
  online_large_payout: '大额收款人',
  payout_payment: '付款',
  large_value_payment: '大额付款',
  payment_link: 'Payment Links',
  reference_detail: '批次详情',
  link_transaction_detail: '链接交易详情',
  payout_approval: '放款审核',
  payment_page: 'Payment Page',
  edit_payment_information: '编辑收款信息',
  checking_order: '交易管理',
  link_information: '页面管理',
  create_mch_code: '商户码创建',
  qr_stand: '收款码',
  qr_stand_list: '收款码列表',
  supplementary_info: '补充资料',
  va_collection: 'VA 收款',
  va_account: 'VA账户',
  va_collection_query: 'VA 交易查询',
  merchant_list: '商户列表',
  merchants: '商户管理',
  refund: '退款交易',
  notifications: '通知',
  checkout: '收银台',
  orders: '订单列表',
  batch_payment_details: '批次上传记录',
  fx_transactions: '换汇交易',
  fx_query: '换汇查询',
  split_transaction: '分账交易',
  card_verification_list: '验卡列表',
  service_provider_tools: '服务商工具',
  transaction_records: '交易记录',
  static_qr: '静态码',
  accept_payments: '收款工具',
  operation_manage: '运营管理',
  business_manage: '业务管理',
  franchisee_manage: '加盟商管理',
  franchisee_create: '新增加盟商',
  franchisee_edit: '编辑加盟商',
  franchisee_detail: '加盟商详情'
}
